export const appName = "DiscDog";
